import React from 'react';
import PropTypes from 'prop-types';

import { format, isPast } from 'date-fns';

import { manageTranslations as TranslationHelper } from '@morsedigital/i18n_helper';

const wp = TranslationHelper('javascript')('weekly_programme');

const sessionState = (start, finish, time) => {
  if (isPast(start))
    return {
      css: 'now',
      title: 'This session has started',
    };
  if (isPast(finish))
    return {
      css: 'old-session',
      title: 'This session has finished',
    };
  return {
    css: '',
    title: `This sessions runs between ${time}`,
  };
};

const formatTime = (start, finish) => `${format(start, 'HH:mm')}-${format(finish, 'HH:mm')}`;

const Time = ({ cancelled, className, start, finish, wrapper }) => {
  const time = formatTime(start, finish);
  const { css, title } = sessionState(start, finish, time);
  return (
    <div className={className}>
      <div className={[wrapper, css]}>
        {cancelled && <span title={`The session between ${time} is cancelled`}>{wp('additional.cancelled')}</span>}
        {!cancelled && <span title={title}>{time}</span>}
      </div>
    </div>
  );
};

Time.propTypes = {
  cancelled: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
  finish: PropTypes.instanceOf(Date).isRequired,
  wrapper: PropTypes.string,
};

Time.defaultProps = {
  wrapper: '',
};

export default Time;
